<template>
	<div>


		<div style="display: flex;align-items: center;justify-content: space-around;">
			<div class="cb_l">
				<div class="bjt1">
					<div><img :src="img1" alt="" /></div>
					<div>监控摄像头-东区试验监控</div>
				</div>
				<div class="v1">
					<div style="width: 90px;height: 90px;">
						<img :src="img2" alt="" style="width: 90px;height: 90px;" />
					</div>
					<div>摄像头离线</div>
					<div class="b1">东区试验监控</div>
				</div>
			</div>
			<div class="cb_r">
				<div class="bjt1">
					<div><img :src="img1" alt="" /></div>
					<div>监控摄像头-西区试验监控</div>

				</div>
				<div class="v1">
					<div style="width: 90px;height: 90px;">
						<img :src="img2" alt="" style="width: 90px;height: 90px;" />
					</div>
					<div>摄像头离线</div>
					<div class="b2">西区试验监控</div>
				</div>
				<!-- <div class="v1">
					<video style="	width: 90%;
		height: 21vh;" :src="url" controls></video>
				</div> -->
			</div>
		</div>




	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {
				msg: {},
				img1: require('../assets/icon.png'),
				img2: require('../assets/iconv.png'),
				url: "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/uni-app-video-courses.mp4"
			}
		},
		mounted() {

		},
		methods: {}
	}
</script>

<style scoped lang="less">
	.cb_l {
		width: 22vw;
		height: 30vh;
		background-image: url(/src/assets/video.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.cb_r {
		width: 22vw;
		height: 30vh;
		background-image: url(/src/assets/video.png);
		background-size: 100% 100%;

		background-repeat: no-repeat;
	}

	.bjt1 {

		display: flex;
		justify-content: center;
		align-items: center;
		height: 55px;
		
	}

	.bjt1>div:nth-of-type(1) {
		width: 30px;
		height: 24px
	}

	.bjt1>div>img {
		width: 30px;
		height: 24px
	}

	.bjt1>div {
		text-align: center;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		font-size: 18px;
		color: #11E5C0;
		font-weight: 600;

	}

	.v1 {
		width: 90%;
		height: 21vh;
		margin: 10px auto;
		background-color: RGBA(58, 78, 85, 1);
		position: relative;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

	}

	.b1 {
		width: 145px;
		height: 36px;
		background-image: url(/src/assets/d.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0px;
		top: 15px;
		color: #fff;
		font-weight: 600;
	}

	.b2 {
		width: 145px;
		height: 36px;
		background-image: url(/src/assets/x.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0px;
		top: 15px;
		color: #fff;
		font-weight: 600;
	}
</style>